export default {"src":"/_next/static/media/section6-img.65d777f1.svg","height":339,"width":462,"blurWidth":0,"blurHeight":0};